import { ThemeUICSSObject } from 'theme-ui';
import { spacing } from '../../../../util';

export const information: ThemeUICSSObject = {
  width: '100%',

  thead: {
    tr: {
      th: {
        bg: 'primary',
        color: 'white',
        textAlign: 'center',
        fontWeight: 'bold',
        p: spacing(4),
      },
    },
  },

  tbody: {
    tr: {
      'td,th': {
        borderBottom: '1px solid',
        borderBottomColor: 'palette.border.article',
        p: spacing(3),
      },

      '&:last-of-type th, &:last-of-type td': {
        borderBottom: 'none',
      },
      th: {
        textAlign: 'left',
        verticalAlign: 'top',
        whiteSpace: 'nowrap',
        minWidth: 'min-content',
        width: 0,
      },
    },
  },
};
